/* eslint-disable no-restricted-imports */
import { ethers } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { ROCKET_POOL_DEPOSIT_POOL, ROCKET_POOL_ERC20 } from '../constants';
export var Deposit = createPlugin({
    protocol: 'ROCKETPOOL',
    type: 'ACTION',
    method: 'deposit',
    name: 'stake',
    supportedContracts: ROCKET_POOL_DEPOSIT_POOL,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            value: new FctValue({}),
            methodParams: {},
        },
        output: {},
    }); },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var _a;
        var to = params.to, value = params.value;
        if (!to.value || !value.value || !vaultAddress)
            return [];
        if (typeof to.value !== 'string' || typeof value.value !== 'string')
            return [];
        var rETH = (_a = ROCKET_POOL_ERC20.find(function (token) { return token.chainId === Number(chainId); })) === null || _a === void 0 ? void 0 : _a.address;
        if (!rETH)
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: ethers.constants.AddressZero,
                        amount: value.value,
                    },
                ],
                toReceive: [
                    {
                        token: rETH,
                        amount: value.value,
                    },
                ],
            },
        ];
    },
});
